@if (icons().length) {
  <span class="vis-icons" role="img" [attr.aria-label]="ariaLabel()">
    @for (item of icons(); track item.audience) {
      <span [class]="'vis-icons__icon vis-icons__icon--' + item.tone" [title]="item.tooltip">
        <i [class]="item.icon" aria-hidden="true"></i>
      </span>
    }
  </span>
}
